import React, { useEffect } from 'react';
import styled from 'styled-components';
import { upperFirst } from 'lodash';
import { FILTER_STRATEGY } from '../../../components/connex-data-grid/util';
import FlexColumn from '../../order/components/FlexColumn';
import useSetup from '../useSetup';
import { useParams } from 'react-router';
import style from './style';
import SetupTable from '../components/setup-table';
import Editor from './concrete-class-editor';

const prototype = {
  id: '',
  name: '',
  status: 'ACTIVE',
};

const columns = [
  {
    key: 'id',
    name: 'ID',
    hidden: true,
  },
  {
    key: 'isDefault',
    name: 'Default',
    getValue: item => item?.isDefault === true ? 'true' :  '',
  },
  {
    key: 'name',
    name: 'Name',
  },
  {
    key: 'description',
    name: 'Description',
  },
  {
    key: 'nominalValue',
    name: 'Nominal Value',
  },
  {
    key: 'minimumValue',
    name: 'Minimum Value',
  },
  {
    key: 'maximumValue',
    name: 'Maximum Value',
  },
  {
    key: 'classType',
    name: 'Class Type',
    getValue: item => upperFirst(item?.classType),
  },
  {
    key: 'status',
    name: 'Status',
    filterStrategy: FILTER_STRATEGY.EQUALS,
    filterComponent: ({ innerRef, ...props }) => {
      return (
        <select ref={innerRef} {...props}>
          <option value="" />
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      );
    },
  },
];

const Styled = styled(FlexColumn)`
  ${style}
`;

const SetupConcreteType = () => {
  const { entityRef } = useParams();
  const { getSetupItems, setupItems, busy } = useSetup('concrete-class');
  const params = { activeOnly: false };

  useEffect(() => {
    entityRef && getSetupItems(params);
  }, [entityRef, getSetupItems]);

  return (
    <Styled>
      <SetupTable
        busy={busy}
        type="Concrete Class"
        columns={columns}
        items={setupItems}
        Editor={Editor}
        prototype={prototype}
        onRefresh={() => getSetupItems(params)}
      />
    </Styled>
  );
};

export default SetupConcreteType;
